import { render, staticRenderFns } from "./ListConsumption.vue?vue&type=template&id=53895bb8&"
import script from "./ListConsumption.vue?vue&type=script&lang=js&"
export * from "./ListConsumption.vue?vue&type=script&lang=js&"
import style0 from "./ListConsumption.vue?vue&type=style&index=0&id=53895bb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports